import Scene3d from "./Scene3d";

// Modules

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js'

export default class Scene3dSMAA extends Scene3d{

    constructor(...args){
        super(...args)
    }

    animate(){
        this.raf = requestAnimationFrame(() => this.animate())
        this.onRender()
        this.composer.render()
        // this.renderer.render(this.scene, this.camera)
    }

    /** Init */
    
    init(){
        super.init()
        this.initPostProcessing()
    }

    initPostProcessing(){
        // post process
        this.composer = new EffectComposer(this.renderer)
        this.composer.addPass(new RenderPass(this.scene, this.camera))

        this.pass = new SMAAPass(
            this.container.offsetWidth * this.renderer.getPixelRatio(),
            this.container.offsetHeight * this.renderer.getPixelRatio(),
        )
        this.composer.addPass(this.pass)
    }

    onWindowResize(){
        super.onWindowResize()
        
        // post process

        this.camera.aspect = this.container.offsetWidth / this.container.offsetHeight;
        this.camera.updateProjectionMatrix();

        this.renderer.setSize( this.container.offsetWidth, this.container.offsetHeight );
        this.composer.setSize( this.container.offsetWidth, this.container.offsetHeight );
    }
}